// Must be the FIRST import in main.tsx: five surfaces guard their standalone
// main.tsx bootstrap on this flag, and belt-and-braces says it is set before
// any surface module evaluates.
window.__OMNI_SHELL_HOST__ = true

export {}
